<template>
  <TeaserCardsBlock
    :items="items"
    grid-type="stretch"
    :header-gutter="false"
    :max-columns="props.columns"
    link-icon-position="content"
  />
</template>

<script lang="ts" setup>
import { TeaserCardsBlock } from '@hypercodestudio/basler-components';
import type { Props as TeaserCardProps } from '@hypercodestudio/basler-components/dist/components/modules/TeaserCard.vue';

type Props = {
  columns?: number;
  itemCount?: number;
};

const props = withDefaults(defineProps<Props>(), {
  columns: 3,
  itemCount: 6
});

const items = new Array(props.itemCount).fill(0).map<TeaserCardProps>(() => ({
  headerGutter: false,
  header: {
    type: 'image',
    content: {
      src: ''
    }
  },
  badge: 'Badge',
  badgeStyle: 'primary',
  headline: 'Headline',
  content: 'Content',
  link: '',
  linkIconPosition: 'content',
  tagList: null,
  isLoading: true
}));
</script>
